// extracted by mini-css-extract-plugin
export default {"dayTitle":"MessagesDay_dayTitle__VSO1k","dayWrapper":"MessagesDay_dayWrapper__nC2CN"};